<mat-card>
    <mat-card-content>

        <!-- Informacje o zamówieniu -->
        <div class="order-header" *ngIf="orderId">
            <div *ngIf="isLoadingOrder" class="loading-row">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Wczytywanie danych specyfikacji...</span>
            </div>
            <h1 *ngIf="!isLoadingOrder && order" class="order-info">
                <span class="order-label">Specyfikacja:</span>
                <strong>
                    {{ (order?.orderTitle?.countBeforeHardening ?? order?.orderTitle?.count) }}/{{
                    order?.orderTitle?.year }}
                    <span *ngIf="order?.companyName"> – {{ order.companyName }}</span>
                </strong>
            </h1>
        </div>

        <form [formGroup]="form">

            <!-- Wybór języka -->
            <mat-form-field appearance="fill" class="full-width language-field">
                <mat-label>Wybierz język</mat-label>
                <mat-select formControlName="language" [disabled]="hasUnsavedChanges">
                    <mat-option value="PL">PL</mat-option>
                    <mat-option *ngFor="let lang of languages" [value]="lang.name">
                        {{ lang.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <ng-container *ngIf="hasUnsavedChanges">
                <mat-error class="unsaved-changes-warning">
                    Masz niezapisane zmiany.
                </mat-error>
            </ng-container>

            <div *ngIf="isLoadingDocument" class="loading-row" style="margin-bottom: 12px;">
                <mat-spinner diameter="18"></mat-spinner>
                <span>Wczytywanie zapisanej wersji językowej...</span>
            </div>



            <!-- Pola zmiennych szablonu -->
            <div class="variables-section">
                <h3 class="section-title">Szczegóły</h3>

                <div class="variable-group" *ngFor="let group of groupedVariables">
                    <h4 class="group-title">{{ group.label }}</h4>

                    <!-- Specjalny układ dla grupy 0.2 (Typ, wariant, wersja) -->
                    <ng-container *ngIf="group.group === '0.2'">
                        <div class="fields-grid">
                            <!-- Standardowe pola (type, variant) -->
                            <ng-container *ngFor="let variable of group.variables">
                                <ng-container *ngIf="variable.key !== '{{version}}' && !isVersionSubfield(variable)">
                                    <ng-container
                                        *ngTemplateOutlet="variableFieldTemplate; context: { $implicit: variable }">
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>

                        <!-- Podpola wersji (tylko dla określonych zabudów) -->
                        <div class="version-subfields-container" *ngIf="showVersionSubfields">
                            <div class="version-subfields-row">
                                <!-- <ng-container *ngIf="visibleVersionSubfields.tonnage">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionTonnage')">
                                            Tonaż
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <input matInput formControlName="versionTonnage">
                                    </mat-form-field>
                                </ng-container> -->

                                <ng-container *ngIf="visibleVersionSubfields.wheelbase">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionWheelbase')">
                                            Rozstaw
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionWheelbase">
                                            <mat-option *ngFor="let opt of wheelbaseOptions" [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.pnr">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionPNR')">
                                            P/N
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionPNR">
                                            <mat-option *ngFor="let opt of getVersionSubfieldOptions('versionPNR')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.trunk">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionTrunk')">
                                            Bagażnik
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionTrunk">
                                            <mat-option *ngFor="let opt of getVersionSubfieldOptions('versionTrunk')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.sideTrunks">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionSideTrunks')">
                                            Boczne
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionSideTrunks">
                                            <mat-option
                                                *ngFor="let opt of getVersionSubfieldOptions('versionSideTrunks')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.space">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionSpace')">
                                            Przestrzeń
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionSpace">
                                            <mat-option *ngFor="let opt of getVersionSubfieldOptions('versionSpace')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <!-- Podpola wersji dla zwykłego Mercedes Benz Tourist Line -->
                                <ng-container *ngIf="visibleVersionSubfields.passengersCode">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionPassengersCode')">
                                            Kod miejsc
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionPassengersCode">
                                            <mat-option
                                                *ngFor="let opt of getVersionSubfieldOptions('versionPassengersCode')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.massCode">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionMassCode')">
                                            Masa
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionMassCode">
                                            <mat-option *ngFor="let opt of getVersionSubfieldOptions('versionMassCode')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="visibleVersionSubfields.wheelchairCode">
                                    <mat-form-field appearance="fill" class="version-subfield">
                                        <mat-label [matTooltip]="getVersionSubfieldTooltip('versionWheelchairCode')">
                                            Wózki inwalidzkie
                                            <mat-icon class="help-icon">help_outline</mat-icon>
                                        </mat-label>
                                        <mat-select formControlName="versionWheelchairCode">
                                            <mat-option
                                                *ngFor="let opt of getVersionSubfieldOptions('versionWheelchairCode')"
                                                [value]="opt.value">
                                                {{ opt.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>
                            </div>

                            <!-- Tabelka pomocnicza: pokazywana, gdy {{versionWheelbase}} nie zostało
                                 ustawione automatycznie (niejednoznaczna liczba pasażerów albo brak
                                 dopasowania - patrz mercedes-tourist-line-highdeck-wheelbase.ts) -
                                 pomaga wybrać właściwy wariant ręcznie z pola "Rozstaw" wyżej. -->
                            <table class="wheelbase-reference-table"
                                *ngIf="wheelbaseReferenceTable.length && !form.get('versionWheelbase')?.value">
                                <caption>Nie udało się automatycznie ustalić rozstawu - wybierz ręcznie:</caption>
                                <tr *ngFor="let row of wheelbaseReferenceTable">
                                    <td>{{ row.code }}</td>
                                    <td>{{ row.description }}</td>
                                </tr>
                            </table>
                        </div>

                        <!-- Pole {{version}} (computed) -->
                        <div class="fields-grid">
                            <mat-form-field appearance="fill" class="full-width" [ngClass]="{'col-span-2': true}"
                                *ngIf="versionVariable">
                                <mat-label>
                                    {{ versionVariable?.label }}
                                    <mat-icon class="help-icon"
                                        [matTooltip]="getTooltipForVariable(versionVariable)">help_outline</mat-icon>
                                </mat-label>
                                <input matInput type="text" formControlName="version" readonly />
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <!-- Standardowy układ dla pozostałych grup -->
                    <ng-container *ngIf="group.group !== '0.2'">
                        <div class="fields-grid">
                            <ng-container *ngFor="let variable of group.variables">
                                <ng-container
                                    *ngTemplateOutlet="variableFieldTemplate; context: { $implicit: variable }">
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Pola domyślnie ukryte (hidden: true) - podgląd i edycja wartości -->
            <div class="hidden-variables-section" *ngIf="groupedHiddenVariables.length">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>Pola domyślnie ukryte</mat-panel-title>
                            <mat-panel-description>
                                Wartości pól niewidocznych w głównym formularzu
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="variable-group" *ngFor="let group of groupedHiddenVariables">
                            <h4 class="group-title">{{ group.label }}</h4>
                            <div class="fields-grid">
                                <ng-container *ngFor="let variable of group.variables">
                                    <ng-container
                                        *ngTemplateOutlet="variableFieldTemplate; context: { $implicit: variable }">
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <ng-template #variableFieldTemplate let-variable>
                <!-- Pole readonly (disabled, uzupełniane automatycznie) -->
                <mat-form-field *ngIf="isVariableDisabled(variable)" appearance="fill"
                    [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <input matInput type="text" [formControlName]="toControlName(variable.key)" readonly />
                </mat-form-field>

                <mat-form-field *ngIf="!isVariableDisabled(variable) && variable.inputType === 'textarea'"
                    appearance="fill" class="full-width" [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <textarea matInput rows="3" [formControlName]="toControlName(variable.key)"
                        [placeholder]="getTooltipForVariable(variable)"></textarea>
                </mat-form-field>

                <!-- Pole liczbowe (np. ceny) -->
                <mat-form-field *ngIf="!isVariableDisabled(variable) && variable.inputType === 'number'"
                    appearance="fill" [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <input matInput type="number" [formControlName]="toControlName(variable.key)"
                        [placeholder]="getTooltipForVariable(variable)" (wheel)="preventNumberScroll($event)" />
                </mat-form-field>

                <!-- Pole daty -->
                <mat-form-field *ngIf="!isVariableDisabled(variable) && variable.inputType === 'date'" appearance="fill"
                    [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <input matInput type="date" [formControlName]="toControlName(variable.key)" />
                </mat-form-field>

                <!-- Waluta -->
                <mat-form-field *ngIf="!isVariableDisabled(variable) && variable.inputType === 'select'"
                    appearance="fill" [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <mat-select [formControlName]="toControlName(variable.key)">
                        <mat-option *ngFor="let option of getSelectOptions(variable)" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Wielokrotny wybór (np. wyposażenie pojazdu) -->
                <mat-form-field *ngIf="!isVariableDisabled(variable) && variable.inputType === 'multiselect'"
                    appearance="fill" class="full-width" [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <mat-select [formControlName]="toControlName(variable.key)" multiple>
                        <mat-option *ngFor="let option of getSelectOptions(variable)" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Tekst (domyślnie) -->
                <mat-form-field
                    *ngIf="!isVariableDisabled(variable) && (!variable.inputType || variable.inputType === 'text')"
                    appearance="fill" [ngClass]="{'col-span-2': variable.colSpan === 2}">
                    <mat-label>
                        {{ variable.label }}
                        <mat-icon class="help-icon"
                            [matTooltip]="getTooltipForVariable(variable)">help_outline</mat-icon>
                        <span *ngIf="variable.requiredTranslation" class="translation-badge"
                            matTooltip="To pole wymaga osobnego tłumaczenia dla każdego języka">🌐</span>
                        <span *ngIf="isOrderDerivedOverridden(variable)" class="override-badge">nadpisane</span>
                    </mat-label>
                    <input matInput type="text" [formControlName]="toControlName(variable.key)"
                        [placeholder]="getTooltipForVariable(variable)"
                        (keypress)="variable.renderAppendKg && restrictMassInputKeypress($event)"
                        (paste)="variable.renderAppendKg && restrictMassInputPaste($event)" />
                </mat-form-field>
            </ng-template>

            <!-- Przyciski akcji -->
            <div class="actions-row">
                <button mat-stroked-button type="button" *ngIf="!isHardened"
                    [disabled]="!form.get('language')?.value || isSaving" (click)="saveDocument()">
                    <mat-spinner *ngIf="isSaving" diameter="16"
                        style="display:inline-block;margin-right:6px;"></mat-spinner>
                    Zapisz
                </button>

                <button mat-stroked-button type="button" *ngIf="!isHardened"
                    [disabled]="!form.get('language')?.value || isSaving" (click)="onHardenClick()">
                    Utwardź
                </button>

                <button mat-stroked-button type="button" [disabled]="!form.get('language')?.value"
                    (click)="previewDocument()" [color]="isPreviewVisible ? 'primary' : ''">
                    {{ isPreviewVisible ? 'Ukryj podgląd' : 'Podgląd' }}
                </button>



                <button mat-stroked-button type="button" *ngIf="canPrint" [disabled]="!form.get('language')?.value"
                    (click)="downloadPdfMake()">
                    Pobierz PDF
                </button>

                <button style="margin-left: auto;" mat-stroked-button type="button"
                    *ngIf="userRole === 'superadmin' && !isHardened"
                    [disabled]="!form.get('language')?.value || isResetting" (click)="resetDocumentTemplate()"
                    matTooltip="" color="warn">
                    <mat-spinner *ngIf="isResetting" diameter="16"
                        style="display:inline-block;margin-right:6px;"></mat-spinner>
                    Resetuj szablon
                </button>
            </div>

            <!-- Iframe podglądu dokumentu -->
            <div *ngIf="isPreviewVisible" class="preview-section">
                <mat-divider></mat-divider>
                <iframe [srcdoc]="previewHtml" class="preview-iframe" sandbox="allow-same-origin"></iframe>
            </div>
        </form>
    </mat-card-content>
</mat-card>